//=====================================================
//　G003カレンダー月表示
//=====================================================
import { useContext, useLayoutEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { getApiData } from "../../utils/CallApi";
import { CtxG003 } from "./G003"
import { G003CalendarMonthlyBody } from "./G003CalendarMonthlyBody";
import { G003CalendarControl } from "./G003CalendarControl";
import { CtxClinicInfo, CtxNewReservation, CtxSystemErr } from "../../utils/Contexts";
import { MsgBoxErr } from "../../common/MsgBoxErr";
import { ConstMsg } from "../../utils/ConstMsg";
import { LoadingBox } from "../../common/LoadingBox";
import { IFUseNewReservation } from "../../utils/UseNewReservation";
import { IFUseAuth, useAuth } from "../../utils/UseAuth";
import { ReservationType } from "../../utils/ConstCommon"

export function G003CalendarMonthly(){
    const [errmess, setErrmess] = useState("");
    const cserr = useContext(CtxSystemErr);
    const ua = useAuth();
    const ctx = useContext(CtxG003);
    const cci = useContext(CtxClinicInfo);                  //医院情報
    const cnr = useContext(CtxNewReservation);              //予約情報
    const [apiData, setApiData] = useState<any>();          //APIデータ格納
    const [loadingDone, setLoadingDone] = useState(false);  //読込中フラグ

    //レンダー後処理：APIデータ取得
    useLayoutEffect(function() {
        // マウントフラグ
        let isMounted = true;

        setLoadingDone(false);
        //cnr.data.medicalTypeIdが無い場合は、リロードの場合とみなしAPI発行を行わない。
        if(cnr.data.medicalTypeId){
            getCalendarMonthlyData(ctx.cDate, cci.data.id, cnr, ua, function(res:any) {
                // アンマウント時はstateを更新しないようにする
                if (isMounted) {
                    if (res?.status) {
                        if (res.status === 200) {
                            setErrmess("");
                            setApiData(res.data);
                        } else if (res.status === 400) {
                            setErrmess(res.data.message);
                        } else if (res.status === 403 || res.status === 404 || res.status >= 500) {
                            cserr.setErrmess(res.data.message);
                        } else {
                            cserr.setErrmess(ConstMsg.EG0030001);
                        }
                    } else {
                        cserr.setErrmess(ConstMsg.EG0030001);
                    }
                    setLoadingDone(true);
                }
            });
        }

        // cleanup関数(Unmount時の処理)
        return() => {
            // マウントオフ
            isMounted = false;
        }
        // エラーメッセージを更新するため、cserrは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctx.cDate, cci.data.id, cnr.data]);

    return (
        <>
            {errmess && <MsgBoxErr text={errmess} />}
            {(apiData !== undefined) && <G003CalendarControl period={apiData.period}/>}
            <LoadingBox overlay={false} loadingDone={loadingDone}>            
                {(apiData !== undefined) &&
                    <table className="calendar">
                        <thead>
                            <tr>
                            <th>月</th>
                            <th>火</th>
                            <th>水</th>
                            <th>木</th>
                            <th>金</th>
                            <th className="text-blue">土</th>
                            <th className="text-red">日</th>
                            </tr>
                        </thead>
                        <G003CalendarMonthlyBody apiData={apiData} />
                    </table>
                }
            </LoadingBox>
        </>
    )

}

//-----------------------------------------------------
//　APIデータを取得
//-----------------------------------------------------
function getCalendarMonthlyData(cDate:Date, clinicId:string, reservation:IFUseNewReservation, ua:IFUseAuth, callback:any):any {
    const year = cDate.getFullYear();
    const month = cDate.getMonth() + 1;
    const reserveId = reservation.data.reserveId;
    const patientId = (reservation.type === ReservationType.First ? "" : ua.getPatientNo());
    
    let apiUrl = `/c/${clinicId}/tables/${reservation.data.medicalTypeId}/${year}/${month}`;
    let apiParams = {
        params: {
            reserveId: reserveId,
            patientId: patientId
        }
    };

    getApiData(
        apiUrl,
        apiParams,
        function(res:AxiosResponse<any>){
            callback(res);
        }
    );
}